import React from 'react';
import PropTypes from 'prop-types';

// Material UI
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { Controller } from 'react-hook-form';
import { ThemeProvider, createTheme } from '@mui/material/styles';

// Custom
import {
    colorPropsTypes,
    marginPropsTypes,
    paddingPropsTypes,
    sizePropsTypes,
} from '@styles/styleProps';
import { GetParsedColor } from '@styles/colors';
import { Box, Icon, Text } from '@components/atoms';

const RadioForm = (props) => {
    const {
        control,
        defaultValue,
        distribution,
        error,
        name,
        options,
    } = props;

    const dark_grey = GetParsedColor('grey.900');
    const light_grey = GetParsedColor('grey.500');
    const green = GetParsedColor('green');
    const blue = GetParsedColor('blue');
    const theme = createTheme({
        overrides: {
            MuiSelect: { icon: { color: light_grey } },
        },
        palette: {
            primary: { main: green },
            secondary: { main: blue },
            text: { primary: dark_grey, secondary: dark_grey },
        },
        typography: { allVariants: { color: dark_grey } },
    });

    const hasDistribution = !!Object.keys(distribution).length;

    return (
        <Box ml="1vw">
            <ThemeProvider theme={theme}>
                <Controller
                    control={control}
                    defaultValue={defaultValue || null}
                    name={name}
                    render={({ field: { onChange, value } }) => (
                        <RadioGroup onChange={(e) => onChange(e)}>
                            {options.map((v, i) => (
                                <Box
                                    display="flex"
                                    flexDirection="column"
                                    justifyContent="space-between"
                                >
                                    {hasDistribution && (
                                    <div style={{
                                        display: 'flex', flexDirection: 'row', width: '100%',
                                    }}
                                    >
                                        <Text
                                            style={{ margin: 0, marginRight: '0.2rem' }}
                                        >
                                            etapa anterior:
                                            {' '}
                                            {Math.round(distribution[v] || 0)}
                                            %
                                        </Text>
                                        <Icon
                                            clickable={false}
                                            color="grey.700"
                                            name="faInfoCircle"
                                            scale={0.8}
                                            tooltipText="Porcentagem de respostas coletadas pelos participantes na etapa anterior"
                                        />
                                    </div>
                                    )}
                                    <FormControlLabel
                                        checked={v === value}
                                        control={<Radio sx={{ marginTop: -1 }} />}
                                        key={i}
                                        label={v}
                                        sx={{ alignItems: 'flex-start', marginBottom: '2vh' }}
                                        value={v}
                                    />
                                </Box>
                            ))}
                        </RadioGroup>
                    )}
                />
            </ThemeProvider>
            {error && typeof error === 'string' && (
                <Text color="red" fontSize={13} ml={2} mt={0.5}>
                    {error}
                </Text>
            )}
        </Box>
    );
};

RadioForm.defaultProps = {
    distribution: {},
    error: undefined,
};

RadioForm.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    distribution: PropTypes.object,
    error: PropTypes.string,
    ...colorPropsTypes,
    ...sizePropsTypes,
    ...marginPropsTypes,
    ...paddingPropsTypes,
};

export default RadioForm;
